import React from 'react';
import { useConversation } from './discovery/useConversation';
import { ChatDataProvider } from './chat/ChatData';
import ChatView from './chat/ChatView';

/** The chat view, filled from the backend. */
const DiscoveryConversation: React.FC = () => (
  <ChatDataProvider value={useConversation()}>
    <ChatView />
  </ChatDataProvider>
);

export default DiscoveryConversation;
